let validURL = function (str) {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_.=]*)?$',
    'i'
  ); // fragment locator

  return !!pattern.test(str) || (str && (str.includes('https:') || str.includes('http:')));
};

let urlWithoutHttpsOrWww = function (url) {
  try {
    return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
  } catch {
    return url;
  }
};

let urlForRedirection = function (url) {
  return `//${urlWithoutHttpsOrWww(url)}`;
};

let seoFriendlyUrl = function (str) {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};

let changeUrl = function (newUrl) {
  if (window && window.history && window.history.pushState) {
    window.history.pushState('', '', newUrl);
  }
};

export default {
  validURL,
  urlWithoutHttpsOrWww,
  changeUrl,
  urlForRedirection,
  seoFriendlyUrl,
};
